import { render, staticRenderFns } from "./HeatmapWidget.vue?vue&type=template&id=13015155&scoped=true&"
import script from "./HeatmapWidget.vue?vue&type=script&lang=js&"
export * from "./HeatmapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13015155",
  null
  
)

export default component.exports